import React, { useState, useEffect, useRef } from 'react'

import axios from 'axios'



const Modal = (props) => {

    //var linkAPI = 'http://172.16.1.253:3700/'
    var linkAPI = 'https://api.hospitaissaudaveis.org/'

    var adesao_institucional_id = props.adesao_institucional_id
    
    var [file, setFile] = useState()
    
    

    function salvar() {


        if (file == '' || file == null) {


            window.toastr.error('Por favor, selecione um arquivo!')
            return false

        }


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma salvar?',
		    buttons: {
		        Sim: function () {

                    

                    const formData = new FormData();
                    const imagefile = document.querySelector("#fileImgCarta");

                    

                    // 'fileimage' é o campo que o 'multer' procura o arquivo de imagem.
                    formData.append("imagemCarta", imagefile.files[0]);
                    //formData.append("ad_usr", sessionStorage.getItem('us_codigo')); // string junto ao formData.
                    
                    //console.log('altera')
                    //return false

                    //console.log(formData)
                    //return false

                    axios.post(`${linkAPI}cartaAdesao/${adesao_institucional_id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'x-access-token': '!nf0$@ud#2',
                    }
                    }).then(response => {

                        //console.log(response.data)
                        window.$("#ModalCartaAdesao").modal('hide');
                        setFile('')
                        props.atualizaCartaAdesao()
                        window.toastr.success('Salvo com sucesso!')



                    }).catch((err) => {

                        console.log(err.response)

                    })


                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });

    }




    return (

        <div>

            <div className="modal fade" id="ModalCartaAdesao" tabindex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 className="modal-title">Carta de Adesão</h1>
                        </div>
                        <div class="modal-body">
                                
                                <div className="panel-body">


                                    
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label>Arquivo</label>
                                                <input type="file" className="form-control" id="fileImgCarta" value={file} onChange={event => setFile(event.target.value)} />
                                                                
                                            </div>
                                        </div>
                                        


                                </div>


                        </div>
                        <div className="modal-footer">

                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            
                            <button type="button" className="btn btn-success" onClick={() => salvar()}>Salvar carta de adesão</button>
                            
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )


}

export default Modal